function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import { Select } from '@mediahuis/chameleon-react';
import language from './language';

var getDefaultCountry = function getDefaultCountry(allCountries) {
  switch (MH_BRAND) {
    case 'dl':
      return 'NL';

    case 'gva':
    case 'nb':
    case 'hbvl':
    case 'ds':
      return 'BE';

    default:
      return allCountries[0].IsoCode;
  }
};
/**
 * @param address
 * @param handleAddressChange
 * @param allowedCountries
 * @param setErrors
 * @param errors
 * @param [SRConfig} config
 * @return {JSX.Element}
 * @constructor
 */


var SelectCountry = function SelectCountry(_ref) {
  var address = _ref.address,
      handleAddressChange = _ref.handleAddressChange,
      allowedCountries = _ref.allowedCountries,
      setErrors = _ref.setErrors,
      errors = _ref.errors,
      config = _ref.config;

  // TODO: Temporary fix until Chameleon fixes
  // error when having <React.Fragment> in options.
  // The correct way should be without .map as this is
  // noticable in performance when rendering the modal.
  // TODO: remove complexity of all countries available, should only use certain countries
  var _useState = useState([]),
      availableCountries = _useState[0],
      setAvailableCountries = _useState[1];

  useEffect(function () {
    fetch("https://" + config.apiPrefix + "addressservice.mediahuis.be/Countries/Language/NL").then(function (response) {
      return response.json();
    }).then(function (allCountries) {
      if (allowedCountries.length === 0) {
        setAvailableCountries([].concat(allCountries));
        handleAddressChange({
          countryCode: address.countryCode || getDefaultCountry(allCountries)
        });
      } else {
        var allowedCountriesWithName = allowedCountries.map(function (allowedCountry) {
          var countriesObject;
          allCountries.forEach(function (country) {
            if (country.IsoCode === allowedCountry.toUpperCase()) {
              countriesObject = _extends({}, countriesObject, country);
            }

            return country;
          });
          return countriesObject;
        });
        setAvailableCountries(allowedCountriesWithName);
        handleAddressChange({
          countryCode: address.countryCode || getDefaultCountry(allCountries)
        });
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Select, {
    id: "country",
    label: language.country,
    "data-testid": "country",
    value: address.countryCode,
    onChange: function onChange(e) {
      handleAddressChange({
        box: '',
        city: '',
        houseNumber: '',
        postalCode: '',
        street: '',
        countryCode: e.target.value
      });

      var spreadedErrors = _extends({}, errors);

      ['box', 'city', 'houseNumber', 'postalCode', 'street'].map(function (key) {
        delete spreadedErrors[key];
        return key;
      });
      setErrors(spreadedErrors);
    }
  }, availableCountries.map(function (country) {
    return /*#__PURE__*/React.createElement("option", {
      key: country.Name,
      value: country.IsoCode
    }, country.Name);
  }));
};

export default SelectCountry;